<mat-form-field class="user-typeahead" appearance="fill">
    <mat-chip-grid #chipList aria-label="User selection" max-length>
        @for (user of selectedUsers; track user) {
            <mat-chip
                [ngClass]="{ 'invalid-chip': user.stateInvalid }"
                (removed)="remove(user.email)"
            >
                {{ displayText(user) }}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
        }
        <input
            placeholder="{{
                TR.key('userManagement.emailInvitation.placeHolder')
            }}"
            #formInput
            [formControl]="formControl"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="inputTokenEnd($event)"
            (paste)="paste($event)"
            [disabled]="disabled"
        />
    </mat-chip-grid>
    @if (maxNumItems > -1) {
        <mat-hint>
            {{ invitationTextHint() }}
        </mat-hint>
    }
    <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="inputAutocompleteSelected($event)"
    >
        @for (item of typeaheadList | async; track item) {
            <mat-option
                class="mat-autocomplete-option"
                [value]="item"
                [disabled]="doesUserAlreadyExist(item)"
            >
                {{ item.getFullDisplayName() }}
                @if (doesUserAlreadyExist(item)) {
                    <span class="mat-autocomplete-already-added">{{
                        TR.key('alreadyadded')
                    }}</span>
                }
            </mat-option>
        }
    </mat-autocomplete>
</mat-form-field>
